let windowGlobal;

export const setWindow = w => (windowGlobal = w);

export const getWindow = () => windowGlobal;



// WEBPACK FOOTER //
// ./app/globals.js